<template>
  <div>
    <b-card>
      <b-card-header class="cardHeader">
        {{ $t("ui.personalData") }}
      </b-card-header>
      <b-row align-h="center">
        <b-col lg="3">
          <label for="vname">{{ $t("personalData.user.firstName") }} </label>
          <b-form-input class="form-control" id="vname" v-model="firstName" />
        </b-col>
        <b-col lg="3">
          <label for="nname">{{ $t("personalData.user.lastName") }} </label>
          <b-form-input class="form-control" id="nname" v-model="lastName" />
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col lg="3">
          <label for="phone">{{ $t("personalData.user.phone") }} </label>
          <b-form-input class="form-control" id="phone" v-model="phone" />
        </b-col>

        <b-col lg="3">
          <label for="mail">{{ $t("personalData.user.email") }} </label>
          <b-form-input id="mail" v-model="mail" :state="mailIsValid" />
        </b-col>

        <b-col lg="3">
          <label for="selectEducation"
            >{{ $t("personalData.user.education") }}
          </label>
          <b-form-select
            id="selectEducation"
            v-model="selectedEducation"
            :options="education"
          >
          </b-form-select>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import store from "@/store/store.js";
import { i18nMixin } from "@/I18N";

export default {
  name: "PersonalData",
  mixins: [i18nMixin],
  methods: {
    validateEmail(email) {
      const regex = /\S+@\S+\.\S+/;
      if (!email || email === "") {
        store.setValidMail(null);
      } else {
        store.setValidMail(regex.test(email));
      }
    },
  },
  created() {
    this.validateEmail(this.mail);
  },
  computed: {
    mailIsValid() {
      return store.isValidMail();
    },
    education() {
      return this.options("personalData", "education", true);
    },
    firstName: {
      get() {
        return store.PersonalData.getFirstName();
      },
      set(firstName) {
        store.PersonalData.setFirstName(firstName);
      },
    },
    lastName: {
      get() {
        return store.PersonalData.getLastName();
      },
      set(lastName) {
        store.PersonalData.setLastName(lastName);
      },
    },
    phone: {
      get() {
        return store.PersonalData.getPhone();
      },
      set(phone) {
        store.PersonalData.setPhone(phone);
      },
    },
    mail: {
      get() {
        return store.PersonalData.getMail();
      },
      set(mail) {
        this.validateEmail(mail);
        store.PersonalData.setMail(mail);
      },
    },
    selectedEducation: {
      get() {
        return store.PersonalData.getEducation();
      },
      set(education) {
        store.PersonalData.setEducation(education);
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
